import { createApp } from 'vue';
import App from './App.vue';
import router from './router/router';
import './styles/nerv.css';

// Explicitly set feature flags
// @ts-ignore
window.__VUE_OPTIONS_API__ = true;
// @ts-ignore
window.__VUE_PROD_DEVTOOLS__ = false;
// @ts-ignore
window.__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ = false;

createApp(App).use(router).mount('#app');
